import { CustomFieldProps, useField } from 'informed';
import React, { FC, InputHTMLAttributes, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomFormFieldProps } from './contracts';
import { CheckboxBlock, CheckboxBlockProps } from './primitives/CheckboxBlock';
import { getErrorTranslation } from './utils';
import { ValidatorMessage } from '@/helpers/validators';

export const Checkbox: FC<
  Omit<CheckboxBlockProps, 'error' | 'id'> &
    CustomFormFieldProps &
    InputHTMLAttributes<HTMLInputElement>
> = ({
  translateError = true,
  formId,
  onClick,
  label,
  tooltip,
  error: propsError,
  ...fieldProps
}) => {
  const { t } = useTranslation();

  const { fieldState, fieldApi, render, ref } = useField<
    CustomFieldProps<CustomFormFieldProps, boolean>,
    boolean
  >(fieldProps);

  const { value, error } = fieldState;
  const { setValue, setTouched } = fieldApi;

  const id = `${fieldProps?.name}${'-' + formId || ''}`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.checked);
    setTouched(true);
  };

  const getError = useCallback(() => {
    if (propsError) propsError;

    if (error != null && translateError) {
      return getErrorTranslation(t, error as ValidatorMessage);
    }

    return error;
  }, [t, propsError, translateError, error]);

  return render(
    <CheckboxBlock
      ref={ref}
      label={label}
      id={id}
      error={<>{getError()}</>}
      onChange={handleChange}
      onClick={onClick}
      checked={value}
      tooltip={tooltip}
    />
  );
};
